import { createStore } from 'zustand';
import { persist } from 'zustand/middleware';

import { keyBuilder } from '@/react/hooks/useLocalStorage';
import { EndpointAuthorizations } from '@/portainer/users/types';
import { CurrentUserResponse } from '@/portainer/users/queries/useLoadCurrentUser';
import { applyTheme } from '@/react/portainer/services/applyTheme';

type State = {
  user?: CurrentUserResponse;
  authorizations: EndpointAuthorizations;
};

type Functions = {
  clear(): void;
};

export const currentUserStore = createStore<State & Functions>()(
  persist(
    (set) => ({
      user: undefined,
      authorizations: {},
      clear: () => set({ user: undefined, authorizations: undefined }),
    }),
    {
      name: keyBuilder('current_user'),
      getStorage: () => localStorage,
    }
  )
);

// apply the theme whenever the user's theme settings change
currentUserStore.subscribe((state, prevState) => {
  const color = state.user?.ThemeSettings?.color;
  if (color !== prevState.user?.ThemeSettings?.color) {
    applyTheme(color ?? 'auto');
  }
});

// NOTE: deliberately no 'storage' event listener here. Rehydrating this store
// from another tab replaces the whole state and notifies every subscriber,
// including the AngularJS auth sync, which let a still-logged-in tab resurrect
// user data into a tab that had just logged out. Cross-tab theme sync is not
// worth reopening that hole; sync only the theme if it is ever reinstated.
